import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BeyondTheMap from "./sections/BeyondTheMap";
import GlobalLogisticsPartners from "./sections/GlobalLogisticsPartners";
import ByTheNumbers from "./sections/ByTheNumbers";
import OurTechnologicalEcosystem from "./sections/OurTechnologicalEcosystem";
import MasteringTheArtOfHardscape from "./sections/MasteringTheArtOfHardscape";
import ActivateYourDataStack from "./sections/ActivateYourDataStack";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BeyondTheMap />
      <GlobalLogisticsPartners />
      <ByTheNumbers />
      <OurTechnologicalEcosystem />
      <MasteringTheArtOfHardscape />
      <ActivateYourDataStack />
      <CorporateFooter />
    </div>;
}